import React from "react";
import Diagrama from "../../../assets/images/diagrama_pacote.jpeg";
import Internet3 from "../../../assets/images/internet2.png";
import InternetMundial from "../../../assets/images/internetmundial.png";
import Satelite from "../../../assets/images/satelites.jpg";

import './styles.css';

const Internet = () => {
    return (
        <div className="containet">
            <div className="row">
                <div className="internet-title">
                    <h1>O que é a internet?</h1>
                    <span>
                        Henrique Leandro Gobi<br />
                        28/09/2023
                    </span>
                </div>

                <div className="col-sm-12">
                    <div className="internet-text">
                        <p>
                            A internet é uma rede global de dispositivos interconectados, que permite a
                            troca de informações e o compartilhamento de recursos, claro, a nível global.
                        </p>
                        <div className="rede-mundial">
                            <div className="rede-mundial-mapa">
                                <img src={InternetMundial} alt="internet" />
                                <span>
                                    Fonte: https://www.curtamais.com.br/goiania/satelite-nada-disso-a-internet-que-voce-usa-e-via-super-cabos-no-fundo-do-mar
                                </span>
                            </div>
                            <div className="rede-mundial-mapa">
                                <img src={Satelite} alt="satelite" />
                                <span>
                                    Fonte: https://pplware.sapo.pt/informacao/starlink-rede-4425-satelites-internet-operacional-ate-2024/
                                </span>
                            </div>
                        </div>
                        <br /><br />
                        <p>
                            Ela conecta bilhões de dispositivos, como computadores, smartphones, tablets
                            e servidores, em todo o mundo através de uma estrutura de um emaranhado de interconexões.
                        </p>
                        <p>
                            Pensamos nela como uma imensa teia de fios invisíveis, que conectam um aparelho a outro,
                            capaz de trocar informação entre si, e entre servidores, tais como do YouTube, Facebook,
                            dentre tantos outros.
                        </p>
                        <p>
                            Assim, não há um ponto central da internet, mas sim um emaranhado de comunicações entre
                            todos os dispositivos conectados na internet.
                        </p>
                    </div>
                </div>

            </div>
            <hr />
            <div className="row">
                <div className="internet-title">
                    <h1>Como ela funciona?</h1>
                </div>
                <div className="col-sm-12 col-md-4">
                    <img src={Internet3} alt="internet" />
                </div>
                <div className="col-sm-12 col-md-8">
                    <div className="internet-text">
                        <p>
                            A internet funciona através de uma série de protocolos que viabilizam a comunicação,
                            sendo o Protocolo de Controle de Transmissão/Protocolo de Internet (TCP/IP) o mais comum.
                            Esse protocolo divide as informações em pequenos pacotes de dados, que são enviados entre
                            os dispositivos através de uma variedade de meios de comunicação, como redes sem fio,
                            satélites e cabos de fibra óptica.

                        </p>
                        <p>
                            E, além do meio físico, há uma divisão por camadas virtuais, abstratas, pode-se dizer, as
                            quais levam o pacote de dados de uma para outra,
                            preenchendo-o em cada uma delas, com informações inerentes da funcionalidade de cada.
                        </p>
                        <p>
                            Pensaremos em um prédio, que para chegar no apartamento desejado, necessitamos das informações
                            de onde o edifício está, o seu endereço na cidade, estado e país. Após, o número do andar
                            do apartamento, e depois, o número do apartamento desejado, assim é a divisão por camadas
                            na rede, onde o pacote, para se movimentar entre remetente e destinatário, tem de passar
                            por lugares, colhendo e anotando essas informações, para que consiga ir e voltar quando necessário.
                        </p>
                        <p>
                            Os dados, nos pacotes, são transmitidos pela internet e podem ser de diferentes tipos, como
                            texto, imagens, vídeos e áudio. Esses dados são enviados de um dispositivo para outro usando
                            endereços IP (Protocolo de Internet), que são identificadores únicos para cada dispositivo
                            conectado à rede.
                            O IP em questão, é um componente das tais camadas virtuais anteriormente mencionadas.
                        </p>
                        <p>
                            Vamos nos ater um pouco sobre o IP. Aqui podemos dividi-lo em duas categorias, endereços de IP Públicos
                            e IP Internos, os Públicos, todos na rede de internet conseguem alcançar, os Internos ficam na rede
                            local do cliente, no roteador, nos aparelhos do cliente e em locais os quais a rede de internet não
                            conhece, “enxerga”.
                        </p>
                    </div>
                </div>

            </div>
            <div className="row">
                <div className="col-sm-12">
                    <div className="internet-text">
                        <p>
                            Exemplo:<br />
                            Faixa de IP que começa no 10.0.0.0 e vai até o 10.255.255.255 – é uma rede 10.0.0.0 com uma máscara 255.0.0.0 ou /8 (8 bits)
                            Da mesma maneira uma rede de 172.16.0.0 a 172.31.255.255 – é uma rede 172.16.0.0 com uma máscara 255.240.0.0 ou /12 (12 bits)
                            Também, 192.168.0.0 a 192.168.255.255, que é uma rede 192.168.0.0 mascarada por 255.255.0.0 ou /16 (16 bits)
                            E uma faixa especial de 100.64.0.0 a 100.127.255.255 com uma máscara de rede 255.192.0.0 ou /10; esta sub-rede é recomendada de acordo com a RFC6598 para uso como um pool de endereços para CGNAT (Carrier-Grade NAT)

                        </p>
                        <p>
                            Todos esses acima são IPs não Públicos, ou Privados, não são encontrados na internet,
                            não existem publicamente, somente em redes internas.

                        </p>
                        <p>
                            Uma pequena observação quanto aos IPs destinados ao CGNAT, são estabelecidos por uma RFC, que nada mais é que uma documentação, para padronizar o que é correlacionado com a internet como um todo. Para que ninguém
                            venha criar suas próprias regras, e assim impedir, ou dificultar a comunicação entre dispositivos.
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h1>Exemplo de uso:</h1>
                    <h4>Geral</h4>
                    <div className="internet-text">
                        <p>
                            A internet oferece uma ampla gama de serviços e recursos. Alguns dos mais conhecidos são a World Wide
                            Web (WWW), que permite acessar páginas da web usando navegadores, o e-mail, que possibilita enviar
                            mensagens eletrônicas, e as redes sociais, que permitem conectar e interagir com outras pessoas.
                        </p>
                        <p>
                            Além disso, a internet também oferece serviços de streaming de vídeo (Netflix, HBO+, Disney+, Amazon
                            Prime Video), dentre outros, e música como o Spotify e Apple Music, o comércio eletrônico que é
                            composto por uma infinidade de sites, tal como o Mercado Livre, Aliexpress, Shein e por aí vai.
                            Também por serviços bancários online,
                            acesso a notícias e informações, games online, entre muitas outras formas de utilização.
                        </p>
                        <p>
                            Em resumo, a internet é uma rede global de computadores que conecta pessoas e dispositivos diversos em
                            todo o mundo, permitindo o compartilhamento de informações, comunicação e acesso a uma ampla gama de
                            serviços e recursos.

                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h1>Como a internet funciona (uma explicação um pouco mais detalhada).</h1>
                    <h4>Navegação</h4>
                    <div className="internet-text">

                        <p>
                            Vamos imaginar a seguinte situação:<br />
                            Uma pessoa está em casa, usando seu computador para buscar um vídeo de música na
                            internet. Usando um navegador de internet, como o Google Chrome, Firefox, Opera
                            (GX), Brave, entre outros, é escrito na URL do navegador o site do YouTube, digitando
                            “www.youtube.com".
                        </p>
                        <p>
                            Ao escrever no navegador de internet o endereço web do site, é transformado em
                            pequenos pacotes de dados contendo a informação solicitada.
                        </p>
                        <p>
                            É procurado internamente no computador, em seu registro de cache DNS, a informação de qual
                            é o IP do site do YouTube, e caso não tenha, esses pacotes são enviados para o modem/ont do cliente,
                            que sabe para onde direcioná-los, que nesse caso será para o servidor DNS local.
                        </p>
                        <p>
                            Para chegar até o DNS local, o pacote passa pelo dispositivo que está “nateando” (NAT) e enviando IP,
                            através do DHCP. Na maior parte das vezes o modem/ont. Que segue o caminho
                            posteriormente até o provedor, o qual faz o CGNAT e envia até o seu roteador de Borda.
                        </p>
                        <p>
                            O DNS local responde para qual endereço de IP deverá seguir o pacote, destinado para o YouTube,
                            assim ele segue o caminho de ida.
                        </p>
                        <p>
                            O provedor de internet, através de um sistema automático, escolhe a melhor rota para enviar estes
                            pacotes ao próximo destino. Caso tenhamos um CDN, servidor de cache do YouTube como nesse caso,
                            o pacote vai até ele e busca o desejado, caso não os pacotes seguem por diferentes
                            redes e servidores no planeta, até chegar ao destino final, o servidor do YouTube.
                        </p>
                        <p>
                            Quando o servidor recebe os pacotes, ele processa a solicitação e retorna os pacotes contendo as
                            informações desejadas. Esses pacotes então seguem o caminho de volta, passando por diferentes
                            servidores e redes, fazendo o
                            caminho inverso que fez na ida, até chegarem de volta ao cliente que solicitou.
                        </p>
                        <p>
                            Dessa forma, a pessoa no computador recebe os pacotes e na tela dele, em seu navegador é exibido o
                            que foi solicitado. Todo esse processo de envio e recebimento de pacotes ocorre de forma rápida e
                            eficiente, permitindo que as informações sejam acessadas em uma fração de segundo.
                        </p>
                        <p>
                            Em resumo, quando alguém faz uma pesquisa na internet, os dados são transformados em pacotes de
                            informações, que são enviados através de uma série de redes e servidores até chegar ao
                            destino desejado. Esse processo ocorre de forma rápida,
                            permitindo o acesso às informações pesquisadas em um curto período de tempo.
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h4>Games</h4>
                    <div className="internet-text">

                        <p>
                            Pensando em outra situação, vamos considerar o seguinte exemplo:<br />
                            Keverson, João e Daniel são jogadores assíduos de jogos online, como o League of Legends (LOL).
                            Eles estão em suas respectivas casas, usando seus computadores, e decidiram jogar algumas partidas
                            juntos. Keverson e Daniel moram na mesma cidade e usam o mesmo provedor de internet, enquanto João
                            está em outra localidade e possui um provedor diferente dos outros dois colegas. Eles iniciam uma
                            partida em equipe.
                        </p>
                        <p>
                            Durante o jogo, João enfrenta um problema com seu personagem. Ele percebe que o tempo de resposta dos
                            pacotes de dados, desde o envio do seu computador até o servidor onde a partida está sendo processada
                            e voltando até sua máquina, está muito alto, ultrapassando 300 milissegundos. Isso equivale a 0,3
                            segundos, ou 30% de um segundo, o que é suficiente para que o personagem não execute corretamente as
                            ações que João deseja realizar. Embora pareça um intervalo curto, na internet, cada milissegundo é
                            crucial. Enquanto isso, Keverson e Daniel têm um tempo de resposta do servidor de 21 milissegundos,
                            o que é consideravelmente menor, 0,021 segundos, contra 0,300 segundos do colega.
                        </p>
                        <p>
                            Essa situação pode ser causada por uma variedade de fatores. Por exemplo, o computador de João pode
                            estar infectado por vírus, apresentar problemas em seus componentes ou ter um cabo de rede conectado
                            ao roteador ou modem/ont de má qualidade ou com defeito. O próprio roteador ou modem/ont também pode
                            estar com problemas. Além disso, pode haver um problema interno no provedor de João ou até mesmo em
                            uma rota específica utilizada por esse provedor para entregar e receber os pacotes de dados até o
                            servidor do League of Legends. Outra possibilidade é que João esteja utilizando uma conexão Wi-Fi
                            distante do roteador, com configurações inadequadas de canal e largura de banda do mesmo.
                        </p>
                        <p>
                            Esses fatores podem afetar a qualidade da conexão de João durante o jogo, resultando em atrasos e
                            problemas de desempenho. É importante considerar todas essas variáveis
                            ao tentar identificar e resolver questões de conectividade em jogos online.
                        </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h4>IPTV</h4>
                    <div className="internet-text">

                    <p>
                        Vamos considerar um cenário bastante comum relacionado a serviços de TV online clandestina, TV box, IPTV
                        e outros termos semelhantes.<br />
                        Existem servidores localizados em diferentes partes do mundo que, de forma ilegal,
                        captam canais de televisão por assinatura e armazenam uma vasta coleção de filmes e
                        séries que normalmente só estão disponíveis em sites de streaming pagos.
                        Esses servidores oferecem esses conteúdos para usuários, mediante o pagamento de uma pequena
                        quantia em comparação ao valor total dos serviços legais que
                        disponibilizam esses filmes, séries, animes e transmissões de campeonatos esportivos.
                    </p>
                    <p>
                        No entanto, esses servidores não oferecem segurança, confiabilidade e estabilidade adequadas,
                        pois operam à margem da lei e não possuem uma estrutura adequada para suportar o uso
                        simultâneo de múltiplos usuários. Podemos fazer uma analogia com um funil, onde a parte
                        mais larga representa os usuários e a parte mais estreita representa o servidor.
                        Isso significa que o servidor é incapaz de atender efetivamente às necessidades de todos,
                        ficando sobrecarregado diante da demanda. Além disso, a maioria desses servidores não está
                        hospedada em máquinas no Brasil, o que resulta em um considerável aumento do tempo de
                        resposta dos pacotes de dados ao percorrerem o caminho de ida e volta até o servidor,
                        levando vários
                        milissegundos ou até mesmo segundos do ponto de origem ao destino, e vice-versa.
                    </p>
                    <p>
                        Outro ponto é que os provedores locais têm se deparado com o cerco mais efetivo da justiça,
                        que determinam que grande operadoras e pontos estratégicos da rede que existe uma grande
                        troca de pacotes/tráfego, para bloquearem alguns endereços de IPs que estes servidores
                        clandestinos utilizem. Assim, algumas rotas na internet já não mais conseguem alcançar
                        esses servidores, ou alcançam de forma que deixam inviável o uso por limitar ainda mais
                        a troca de tráfego até eles, causando lentidão nesses serviços ilegais.
                        Ainda há alguns provedores que possuem algumas rotas as quais ainda não realizaram esse
                        bloqueio, alguns IPTVs ainda operam, porém a grande maioria de provedores, por esse
                        bloqueio que foi realizado acima, nas rotas, percebem que não mais funcionam alguns IPTVs.<br />
                        Esses serviços embora à primeira vista seja uma vantagem ao usuário, por não pagarem um
                        valor maior no acesso a tanto entretenimento, são nocivos ao cliente, por deixá-lo
                        totalmente exposto a um acesso e roubo de informações do usuário. Além de prejudicarem
                        quem trabalha de forma legalizada. Ressaltando que a empresa em si, sem ser através de
                        determinação judicial, não realiza nenhum bloqueio no uso de qualquer serviço.
                    </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h4>Stream</h4>
                    <div className="internet-text">

                    <p>
                        Outro caso importante a ser considerado é o dos streamers, aqueles que fazem transmissões
                        ao vivo no Instagram, YouTube, Twitch e outros serviços semelhantes, as famosas (LIVE’s).
                        Muitas vezes, esses streamers percebem algumas interrupções na
                        transmissão e/ou perda de qualidade na imagem transmitida para o serviço.
                    </p>
                    <p>
                        No caso do Instagram, o streamer utiliza o aplicativo instalado em seu smartphone,
                        que está conectado ao roteador por meio de Wi-Fi. Nesse cenário, há uma série de variáveis
                        que podem influenciar a perda de pacotes na transmissão, como o cabo que conecta o
                        modem/ont ao roteador, a configuração do próprio roteador, a qualidade e o tempo de
                        uso do roteador. Esses fatores impactam diretamente na transmissão sem fio durante a
                        stream/live no Instagram, são os mesmos fatores que impactam em jogos online.
                    </p>
                    <p>
                        Além disso, há o fator do próprio smartphone, sua qualidade, configuração e uso.
                        Se não estiverem adequados, podem resultar em uma experiência ruim,
                        que não está necessariamente relacionada à qualidade da internet.
                    </p>
                    <p>
                        Quando se trata de transmissões feitas por meio de computadores ou notebooks,
                        seja por meio de cabo de rede conectado ao roteador ou diretamente ao modem/ont,
                        entram em jogo outras variáveis. Os dispositivos  em si, como cabos, sua qualidade
                        e tempo de uso, e também a configuração do software utilizado na transmissão/stream/live,
                        como o OBS e outros programas similares, são fatores a serem considerados. Uma configuração
                        inadequada desses softwares pode gerar uma série de problemas,
                        que às vezes são confundidos com problemas na conexão de internet.
                    </p>
                    <p>
                        Também é importante levar em conta o hardware do computador/notebook, pois se estiver
                        sendo usado em sua capacidade máxima, pode não conseguir
                        processar corretamente a transmissão, o que resulta em problemas durante a live.
                    </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h4>Monitoramento (câmeras, automação, sistemas)</h4>
                    <div className="internet-text">

                    <p>
                        Atualmente, há uma demanda crescente por soluções de segurança residencial e
                        empresarial que utilizam a internet para permitir o acesso remoto a câmeras,
                        dispositivos  de armazenamento, sistemas de alarme e controle de acesso.
                        Para viabilizar esse acesso externo aos dispositivos ,
                        são necessárias configurações específicas no modem/ont e roteador.
                    </p>
                    <p>
                        Os principais pontos a serem considerados para possibilitar esse acesso são:<br />
                        Endereço IP público/fixo: É necessário ter um endereço IP público e fixo para que
                        os dispositivos  possam ser acessados remotamente pela internet.
                    </p>
                    <p>
                        Encaminhamento de portas: É preciso configurar o redirecionamento das portas para
                        o endereço IP interno do dispositivo  que se deseja acessar.
                    </p>
                    <p>
                        Resumindo, é necessário ter o IP externo (público/fixo), o IP interno (local)
                        e as portas devidamente configuradas.
                    </p>
                    <p>
                        Uma breve analogia para compreender esses termos é a seguinte:<br />
                        Imagine que você deseja chegar a um determinado destino. Para isso, é preciso conhecer
                        o endereço desse local, que pode ser comparado ao IP público/fixo.
                    </p>
                    <p>
                        Esse destino corresponde a um prédio, e para encontrar o andar específico que você deseja,
                        é necessário saber o número do andar, que seria o IP interno (local).
                    </p>
                    <p>
                        Por fim, para acessar o local desejado no andar correto, é como se você precisasse saber
                        em qual porta deve bater, o que representa as portas na rede.
                    </p>
                    <p>
                        Endereço do Edifício = IP Externo (PÚBLICO/FIXO)
                        Andar do Prédio = IP Interno (LOCAL)
                        Porta no Andar = Porta(s)

                    </p>
                    <p>
                        Dessa forma, o provedor de internet deve fornecer ao cliente um endereço IP público na
                        internet, que seja acessível por qualquer pessoa na rede. No entanto, como os endereços
                        IP são limitados, há um custo associado ao uso de um IP público. Quanto ao IP local,
                        o protocolo DHCP atribui um endereço IP aos dispositivos conectados à rede do cliente,
                        como smartphones, computadores e outros dispositivos. No caso de um sistema, como um
                        sistema de gerenciamento de dados empresarial, por exemplo, é importante fixar um endereço
                        IP para o dispositivos onde o sistema está instalado, pois o DHCP pode alterar o IP
                        constantemente. Por fim, no modem/ont e roteador, são definidas as portas correspondentes
                        ao endereço IP previamente fixado. Dessa maneira, uma pessoa em outro continente,
                        utilizando uma conexão 5G, pode acessar esse sistema ou outro dispositivo remotamente.
                    </p>
                    <p>
                        Hoje, aparelhos mais modernos de sistemas de câmeras, utilizam serviços que “mascaram”
                        os pacotes, e ignoram a necessidade de um IP Público, porém é necessário ainda realizar
                        o redirecionamento de portas no modem/ont do cliente. Todavia, caso feito, e ainda não
                        funcionando, sempre é orientado ao cliente a necessidade de um endereço de IP Público.
                    </p>
                    <p>
                        Essa mesma lógica se aplica a outros casos comuns, como sistemas de gerenciamento de
                        dados empresariais, automações, as quais precisam estar acessíveis remotamente.
                        Nesses casos, também são necessários os mesmos pontos principais mencionados acima:
                        IP externo (público/fixo) do cliente, IP interno (local)
                        onde o sistema está instalado e as portas do sistema/automação correspondente.
                    </p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <h4>Relembrando o caminho do pacote</h4>
                    <p>
                        Em sua televisão de sua casa, a qual está cabeada, ligada no roteador Wi-Fi do cliente
                        (LAN 2), que por sua vez está ligado sua LAN 1, na LAN 1 do MODEM GIGABYTE, você deseja
                        ouvir uma música no YouTube, então nela,
                        no navegador de internet no campo de URL (campo de endereço), você:
                        <br /><br />
                        <ol>
                            <li>
                                Você inicia digitando "www.youtube.com.br" na barra de endereço do navegador.<br />
                                Disso, sua TV busca no CACHE dela, saber qual IP é o endereço que corresponde
                                a URL digitada, seguindo processo:<br /><br />
                            </li>
                            <li>
                                a. Cache local do DNS: O navegador verifica seu cache local do DNS. Se não encontrar
                                a informação, ele consulta um servidor DNS local, no caso o da GIGABYTE, o 177.8.200.10
                                e 177.8.195.10, que é configurado no MODEM.<br />
                                b. Consulta ao servidor DNS local: O navegador envia uma consulta ao servidor DNS local,
                                caso ele não tenha essa informação, ele ainda pode consultar outros servidores DNS de
                                nível superior (NA INTERNET), se necessário, para assim encontrar o IP de
                                www.youtube.com.br.<br />
                                c. Resolução completa: O servidor DNS local retorna o endereço IP associado a
                                www.youtube.com para o navegador da TV.<br />
                                Resumindo, o DNS “só” fala que IP corresponde a tal endereço de texto, a URL.<br />
                                Daí começa a viagem do pacotinho, quando é gerado:<br /><br />
                            </li>
                            <li>
                                O pedido HTTP: Com o endereço IP de www.youtube.com.br (por exemplo, 216.58.214.206) em mãos,
                                o navegador envia uma solicitação para esse endereço.<br />
                                É feito um pacote de dados que saí da TV em direção ao MODEM, para que volte com o solicitado.
                                <br /><br />
                            </li>
                            <li>
                                Roteamento local: O pacote de dados com a solicitação é encaminhado para o MODEM da LAN do
                                cliente, que tem o IP 192.168.0.1/24.
                                <br /><br />
                            </li>
                            <li>
                                Roteador e DHCP: O roteador local atua como um servidor DHCP e atribui endereços IP internos
                                aos dispositivos na LAN, como mencionado anteriormente.<br />
                                Por exemplo, sua TV pode receber o endereço IP 192.168.0.3/24
                                <br /><br />
                            </li>
                            <li>
                                NAT (Tradução de Endereços de Rede): Antes de encaminhar o pacote para a WAN, o roteador local
                                executa a Tradução de Endereços de Rede (NAT).<br />
                                Tradução de Endereços: O roteador realiza a NAT para mapear o endereço IP interno (192.168.0.3)
                                para o endereço IP do CGNAT (por exemplo, 100.64.0.1). Isso é feito para que o pacote pareça
                                ter vindo do endereço IP do CGNAT, permitindo que a resposta seja roteada corretamente de
                                volta para o roteador.
                                <br /><br />
                            </li>
                            <li>
                                Encaminhamento para a WAN: Após a tradução de endereços, o roteador encaminha o pacote
                                para a WAN, enviando-o então para o Provedor de Internet.
                                <br /><br />
                            </li>
                            <li>
                                CGNAT: No nível do Provedor de Internet, o pacote de dados passa por um dispositivo
                                de CGNAT, que substitui o endereço IP do cliente, dado pelo Provedor
                                (por exemplo, 100.64.0.1) por um dos endereço IP público destinados ao CGNAT
                                (por exemplo, 186.95.96.96), que faz parte
                                de bloco de IPs que o Provedor define para os clientes alcançarem a internet.
                                <br /><br />
                            </li>
                            <li>
                                Provedor de Internet: O pacote, agora com o endereço IP público do CGNAT,
                                é encaminhado pelo Provedor de Internet para a Internet pública.
                                <br /><br />
                            </li>
                            <li>
                                CDN do YouTube: O pacote atinge a CDN (Rede de Distribuição de Conteúdo) do YouTube,
                                que é uma rede de servidores distribuídos globalmente, incluindo servidores locais em
                                vários locais geográficos. O CDN do YouTube é
                                projetado para entregar vídeos de forma eficiente e reduzir a latência.
                                <br /><br />
                            </li>
                            <li>
                                Roteamento interno: O pacote viaja pela infraestrutura de roteamento ainda interno
                                até alcançar a CDN do YouTube. Esse Servidor de Cache Local: Na CDN do YouTube é
                                armazenado cópias de vídeos populares. Isso permite que o conteúdo seja entregue
                                mais rapidamente, uma vez que não precisa ser buscado no servidor central do YouTube.
                                <br /><br />
                            </li>
                            <li>
                                Roteamento para o Servidor de Vídeo: Se o vídeo não estiver em cache local, a CDN
                                encaminhará o pacote para o servidor central
                                do YouTube, agora a nível global, responsável por entregar o vídeo.
                                <br /><br />
                            </li>
                            <li>
                                Processamento e Entrega: O servidor central do YouTube processa a solicitação e
                                entrega o vídeo solicitado, que é empacotado em um pacote de dados de resposta.
                                <br /><br />
                            </li>
                            <li>
                                Roteamento de volta: A resposta é enviada de volta ao seu computador, seguindo o caminho inverso.
                                <br /><br />
                            </li>
                            <li>
                                Provedor de Internet local: A resposta chega ao Provedor de Internet local e é
                                encaminhada para o dispositivo de CGNAT.
                                <br /><br />
                            </li>
                            <li>
                                CGNAT: O dispositivo de CGNAT traduz o endereço IP público de volta para o
                                endereço IP interno associado ao cliente (por exemplo, 100.64.0.1).
                                <br /><br />
                            </li>
                            <li>
                                Roteamento local cliente: A resposta é encaminhada pelo modem, que pelo NAT,
                                envia para a TV com o endereço IP
                                interno que originou o pacote, no caso do exemplo o 192.168.0.3/24.
                                <br /><br />
                            </li>
                            <li>
                                Exibição no navegador: O navegador recebe a resposta e a exibe na tela.
                                <br />
                            </li>
                        </ol>
                        Este cenário descreve como a CDN do YouTube é usada para entregar vídeos de forma
                        eficiente, aproveitando servidores de cache locais e uma rede global de servidores
                        para melhorar a experiência de streaming de vídeo para os usuários.
                    </p>
                </div>
            </div>
            <img src={Diagrama} alt="diagrama" />
        </div>
    );
};
export default Internet;